import type { PropsWithChildren, ReactElement } from "react";
import {
  hasRole,
  useAbility,
  useCurrentOrganizationRoles,
  type Action,
} from "@/partner/shared/lib";
import type { OrganizationRoleType } from "@/types/graphql/partner";
// AccessDeniedScreen импортируется напрямую из ui-сегмента фичи, а не через
// её index.ts (тот резолвится в тип "features", который shared по
// eslint-plugin-boundaries импортировать не может). Deep-импорт из
// features/*/ui/* резолвится в отдельный тип "feature-ui", для него это
// разрешено — тот же приём, что и Filter.tsx (shared/components), см.
// комментарий про LanguageField в shared/ui/index.ts.
import { AccessDeniedScreen } from "@/partner/features/auth/ui/AccessDeniedScreen/AccessDeniedScreen";

export type RequireAbilityProps = PropsWithChildren<
  | { action: Action; subject: string; roles?: never }
  | { action?: never; subject?: never; roles: OrganizationRoleType[] }
>;

/**
 * Гейт страниц (app/router.tsx), та же таблица доступа, что у пунктов
 * меню (shared/constants/menu.ts). При отказе — AccessDeniedScreen вместо
 * содержимого страницы (спека, «Меню и маршруты»).
 */
export const RequireAbility = (props: RequireAbilityProps): ReactElement => {
  const ability = useAbility();
  const currentOrganizationRoles = useCurrentOrganizationRoles();

  const allowed = props.roles
    ? hasRole({ currentOrganizationRoles }, ...props.roles)
    : ability.can(props.action, props.subject);

  if (!allowed) {
    return <AccessDeniedScreen variant="page" />;
  }

  return <>{props.children}</>;
};
